import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { ChevronLeftIcon, Text } from '@beef/ui-kit';
import { Link } from 'react-router-dom';

import styles from './styles.pcss';
import { BackLinkProps } from './types';

const cn = classNames.bind(styles);

export const BackLink: FC<BackLinkProps> = ({ url, text = 'Назад', onClick }) => (
  <Link className={cn('link')} onClick={onClick} to={url}>
    <ChevronLeftIcon fill="#727281" size="m" />
    <Text color="grey60" size="size5-r-s">
      {text}
    </Text>
  </Link>
);
